import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import AppointmentModel from "../../models/appointment";

export default class AppointmentRepository extends BaseRepository {
  static modelClass = AppointmentModel;
  modelName = "appointment";
}
